export default __webpack_public_path__ + "static/media/12.91313a29.webp";